export const sortBySortPriority = (arr = []) => arr.sort((a, b) => (a.sortPriority > b.sortPriority) ? 1 : -1)
